import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import logo from "../../../assets/QuallyHireGreen.png";
import { Radio, Divider, Form, Input, message, Button, TimePicker, Select,Card ,Empty} from "antd";
import Footer from "../../footer";

import "./jobListingSearchResults.scss";
import JobListingSearchResultFilter from "../jobListingSearchResultFilter"
import useNuJobsStore from "../../../store/nujobs.store";
import JobListingSearchResultCards from "../jobListingSearchResultCards";

export default function JobListingSearchResults(props) {
  const { getOSAllJds, similaryJdStats, openJds } = useNuJobsStore();
  const navigate = useNavigate();


  const handleSignin = () => {
    navigate('/login')
  };

  const handleSignup = () => {
    navigate('/signup')
  };

  const handleJobSeekers = () => {
    navigate('/jobSeekers')
  };

  const handleCareerListing = () => {
    navigate('/jobSeekers')
  };

  const handleUpdateFormSubmit = () => {
    navigate('/jobSeekers')
  };

  useEffect(() => {
  }, []);


  return (
    <div className="jobListing-wrapper">
       <div className="jobListing-header-results"> 
          <div className="header-logo">
              <img className="header-logo-img"src={logo} />
              <div className="header-logo-name">
                  Quallyhire AI
              </div>
          </div>
          <div className="header-menu">
            <ul className="header-menu">
              <li >
                <a href="/">Home</a>
              </li>
              <li>
                
              <a href="/jobSeekers">JobSeekers</a>
              </li>
              <li>
                Support 
              </li>                                          
            </ul>
          </div>
          <div className="header-sign">
            <Button className="sign-button" onClick={() => handleSignin()}>
              Post 5 Free Jobs
            </Button>
            <Button className="job-button" onClick={() => handleJobSeekers()}>
              Employers
            </Button>                                     
          </div>          
       </div>

       <div className="jobListing-title">
         <div className="jobListing-puncLineSmall">
            Search IT and Software Jobs in Our Platform
         </div>
         <div className="jobListing-search-wrapper">
            <Form
                className="jobListing-search-wrapper"
                name="jobListing-search"
                autoComplete="off"
                onFinish={handleUpdateFormSubmit}
            >
                <div className="jobListing-search">
                     <Form.Item
                        name="keywords"
                    >
                        <Input
                            className="jobListing-search-item"
                            type="text"
                            required= {true}
                            placeholder={"Keywords"}
                        />
                    </Form.Item>
                    <Form.Item
                        name="location"
                    >
                            <Select
                                mode="multiple"
                                placeholder={"location"}
                                allowClear                             
                                required={ true}
                                className="jobListing-search-item"                            
                                options={[
                                    { value: 'Bengaluru', label: 'Bengaluru' },
                                    { value: 'Chennai', label: 'Chennai' },
                                    { value: 'Hyderabad', label: 'Hyderabad' },
                                    { value: 'Gurgaon', label: 'Gurgaon' },
                                    { value: 'Noida', label: 'Noida'},
                                    { value: 'Delhi', label: 'Delhi' },
                                    { value: 'Mumbai', label: 'Mumbai' },
                                    { value: 'Pune', label: 'Pune' },
                                    { value: 'Kolkata', label: 'Kolkata' },
                                    { value: 'Nagpur', label: 'Nagpur'},
                                    { value: 'Madurai', label: 'Madurai'}, 
                                    { value: 'Raipur', label: 'Raipur'},
                                    { value: 'Chandigarh', label: 'Chandigarh'}, 
                                    { value: 'Ahmedabad', label: 'Ahmedabad'},
                                    { value: 'Indore', label: 'Indore'}, 
                                    { value: 'NAshik', label: 'NAshik ' },
                                    { value: 'Pan India', label: 'Pan India' }, 
                                    { value: 'Remote', label: 'Remote' },
                                    { value: 'Anywhere in India', label: 'Anywhere in India' },
                                    { value: 'Other', label: 'Other' },
                                ]}
                            />                         
                    </Form.Item>                     
                    <Form.Item
                        name="button"
                    >
                      <Button
                        className="jobListing-search-button"
                        type="primary"
                        htmlType="submit"
                      >
                          Search Again
                      </Button>   
                    </Form.Item>   
                </div>                 
            </Form>
         </div>  
            <div className="JobListing-puncLineSmall">
              Showing results for keywords - {similaryJdStats?.similarjds[0]?.keyword} location - {similaryJdStats?.city} 
            </div>                                                                    
       </div>

       <div className="jobListing-Results">
          <div className="jobListing-filters">
            <JobListingSearchResultFilter />
          </div>
          <div className="jobListing-cards">
              <div className="job-listing-result-nums">
                 Resulting <span style={{color : "#008fff"}}>{similaryJdStats?.similarjds[0].numOfJds} </span> jobs matching this criteria
              </div>

              {openJds?.length > 0 ? (
              <>
                {openJds?.map((jd, idx) => (
                    <JobListingSearchResultCards openJd={jd} />
                ))}
              </>
              ) : (
                <Empty style={{ margin: "60px" }} />
              )}               
          </div>
       </div>

       <div className="landing-footer">
          <Footer/>
       </div>         
    </div>
  );
}
